export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/directives/baSlimScroll/index.ts